import { Create, SimpleForm, usePermissions } from "react-admin";
import { OrganForm } from "./OrganForm";
import { useCreateSubmit } from "../../forms";

export const OrganCreate = () => {
	// since some permissions are assigned per organ, they need to be recalculated after new organ gets created
	const { refetch } = usePermissions();
	const submit = useCreateSubmit("organs", "Organ created", undefined, refetch);

	return (
		<Create>
			<SimpleForm onSubmit={submit}>
				<OrganForm />
			</SimpleForm>
		</Create>
	);
};
